import { Component } from "react";
import { EVENT_TYPES } from "../types/EventTypes";
import eventEmitter from "../state/EventEmitter";

export default class SubscribingComponent<P, S> extends Component<P, S> {
  events: { name: EVENT_TYPES; cb: Function }[] = [];

  subscribe(name: EVENT_TYPES, callback: (arg0: any) => any) {
    this.events.push(eventEmitter.subscribe(name, callback));
  }

  componentWillUnmount() {
    this.events.forEach((e) => eventEmitter.unsubscribe(e.name, e.cb));
  }
}
